import {
  Box,
  Button,
  Card,
  Modal,
  TextField,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { H5, Small } from 'components/Typography';
import { useEffect, useState } from 'react';

export default function EditCommentModal({
  showModal,
  setShowModal,
  commentText = '',
  onSave,
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [editedText, setEditedText] = useState(commentText);

  useEffect(() => {
    setEditedText(commentText);
  }, [commentText]);

  const handleClose = () => {
    setShowModal(false);
    setEditedText(commentText);
  };

  const handleSave = () => {
    if (onSave) {
      onSave(editedText);
    }
    setShowModal(false);
  };

  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: isMobile ? '95%' : 600,
    maxWidth: '90vw',
    bgcolor: '#FFFFFF',
    borderRadius: '18px',
    boxShadow: 24,
    outline: 'none',
  };

  return (
    <Modal
      open={showModal}
      onClose={handleClose}
      disableEnforceFocus={true}
      disableBackdropClick={false}
      disableEscapeKeyDown={true}
      aria-labelledby="edit-comment-modal"
      aria-describedby="edit-comment-modal-description"
      BackdropProps={{
        style: {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
        },
      }}
    >
      <Card sx={modalStyle}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            padding: '24px',
            gap: 2,
          }}
        >
          {/* Title */}
          <H5 sx={{ color: '#151515', fontWeight: 600, mb: 0.5 }}>댓글 수정</H5>

          {/* Comment Content Section */}
          <Box>
            <Small
              sx={{
                color: '#151515',
                fontWeight: 500,
                mb: 1,
                display: 'block',
              }}
            >
              댓글 내용
            </Small>
            <TextField
              multiline
              rows={6}
              fullWidth
              value={editedText}
              onChange={e => setEditedText(e.target.value)}
              sx={{
                '& .MuiOutlinedInput-root': {
                  backgroundColor: '#F5F5F5',
                  borderRadius: '12px',
                  '& fieldset': {
                    border: 'none',
                  },
                  '&:hover fieldset': {
                    border: 'none',
                  },
                  '&.Mui-focused fieldset': {
                    border: 'none',
                  },
                },
                '& .MuiInputBase-input': {
                  color: '#151515',
                  fontSize: '14px',
                  lineHeight: 1.5,
                  padding: '12px 16px',
                  fontFamily: 'inherit',
                },
                '& .MuiInputBase-input::placeholder': {
                  color: '#B5B7C0',
                },
              }}
            />
          </Box>

          {/* Action Buttons */}
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              gap: 1,
              mt: 1,
            }}
          >
            <Button
              variant="outlined"
              onClick={handleClose}
              sx={{
                backgroundColor: theme.palette.primary.grey10,
                borderColor: '#E4E7EC',
                color: '#151515',
                borderRadius: '8px',
                px: 3,
                py: 1,
                fontSize: '14px',
                fontWeight: 500,
                textTransform: 'none',
                '&:hover': {
                  backgroundColor: theme.palette.primary.grey10,
                  borderColor: '#CBD0DA',
                },
              }}
            >
              취소
            </Button>
            <Button
              variant="contained"
              onClick={handleSave}
              sx={{
                backgroundColor: theme.palette.primary.mainBlue,
                color: '#ffffff',
                borderRadius: '8px',
                px: 3,
                py: 1,
                fontSize: '14px',
                fontWeight: 600,
                textTransform: 'none',
                boxShadow: 'none',
                '&:hover': {
                  backgroundColor: theme.palette.primary.mainBlueHover,
                  boxShadow: 'none',
                },
              }}
            >
              저장
            </Button>
          </Box>
        </Box>
      </Card>
    </Modal>
  );
}
